export const CHECKOUT_URL =
  'https://rutinasimple.com//cart/53127621607705:1'

/** Único botón que sale hacia Shopify; el resto de CTAs apuntan aquí. */
export const PRIMARY_CTA_ID = 'cta-principal'
